<!-- eslint-disable vue/no-mutating-props -->
<template>
  <b-row
    align-h="between"
    align-v="center"
    class="w-100 "
    @mouseover="onHover"
    @mouseleave="onLeave"
  >
    <b-col
      md="4"
      class="title-config"
    >
      {{ controller.text }}:
    </b-col>
    <b-col
      class="p-0 m-0"
      cols="8"
    >
      <multiselect
        v-model="controller.value"
        class="mt-1 combobox-config shadow-sm"
        :options="controller.options"
        :disabled="controller.options.length === 0 || disabled"
        :placeholder="controller.placeholder"
        :multiple="true"
        :searchable="false"
        :clear-on-select="false"
        :allow-empty="false"
        :close-on-select="false"
        @input="controller.changeSelection(controller.value);setConfigReportModifiedReportViewer()"
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  name:'MultiSelDropdownConfiguration',
  components: {
    Multiselect
  },
  props: {
    controller:{
      type:Object,
      required: true
    },
    disabled:{
      type:Boolean,
      required:false,
      default: false
    }
  },
  methods: { 
    ...mapActions(['setContextOnHover', 'setConfigReportModifiedReportViewer']),
    onHover() {
      if(this.controller.contextHelp!==null){
        this.setContextOnHover(this.controller.contextHelp)
      }
    },
    onLeave(){
      if(this.controller.contextHelp!==null){
        this.setContextOnHover(null)
      }
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.title-config{
  font-size: 0.8rem;
}
</style>